<template>
  <div>
    <v-dialog max-width="80%" v-model="dialog">
      <div>
        <v-card v-if="data">
          <v-card-title>
            <h2>{{ field.name }}</h2>
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <div>
              <img v-if="data" @click="openImage(data,'image/jpg')" style="max-width: 100%;display:block; margin: auto auto;"
                   :src="'data:image/jpg;base64,'+ data"/>
              <div v-else>Brak</div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  color="red" @click="dialog=false">Zamknij</v-btn>
            <v-btn  color="green" @click="downloadImg">Pobierz</v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-else>
          <v-card-title>
            {{ $t('related.no_data') }}
          </v-card-title>
        </v-card>

      </div>

      <template v-slot:activator="{ on }">
        <img @click="openImage(data,'image/jpg')" class="imageField"
             :src="'data:image/jpg;base64,'+ data"/>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import FieldType from "../../../enums/fieldType";

export default {
  components: {},
  props: ["data", "field"],
  data() {
    return {
      dialog: false,
      loading: true,
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  created() {

  },
  methods: {
    openImage() {
      this.dialog = true
    },
    downloadImg(){
      let link = document.createElement('a');
      link.download = this.field.name + ((this.field.type == FieldType.PHOTO) ? '.jpg' : '.png');
      link.href = 'data:image/jpg;base64,'+ this.data
      link.click();
    }
  },
}
</script>

<style scope>
.imageField {
  height: 100px;
  cursor: pointer;
}
</style>
